import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MapService {

  constructor(private http: HttpClient) { }

  async getLogisticLocations(company: string, userCode: string, location: number) {
    return this.http.get<any>(`${environment.baseUrl}/logilite/location?company=${company}&userCode=${userCode}&location=${location}`).toPromise();
  }

  async getRouteCodes(company: string, userCode: string, location: number, docDate: number) {
    return this.http.get<any>(`${environment.baseUrl}/logilite/routes?company=${company}&userCode=${userCode}&location=${location}&docDate=${docDate}`).toPromise();
  }

  async getCounts(company: string, userCode: string, location: number, docDate: number){
    return this.http.get<any>(`${environment.baseUrl}/logilite/counts?company=${company}&userCode=${userCode}&location=${location}&docDate=${docDate}`).toPromise();
  }

  async getCustomerInfoByRoute(company: string, userCode: string, location: number, docDate: number,routes:string){
    return this.http.get<any>(`${environment.baseUrl}/logilite/customer?company=${company}&userCode=${userCode}&location=${location}&docDate=${docDate}&route=${routes}&keyword=`).toPromise();
  }
  
  async getRouteSequencey(company: string, userCode: string, location: number, docDate: number,routes:string){
    return this.http.get<any>(`${environment.baseUrl}/logilite/route-sequencing?company=${company}&userCode=${userCode}&location=${location}&docDate=${docDate}&route=${routes}`).toPromise();
  }
}
